// Generated by `bazel run i18n`. Do not edit by hand.
import home_48172dae from "./en/account--app--src--account--home.json";
import lists_05f113fc from "./en/account--app--src--account--lists.json";
import orders_ef59f554 from "./en/account--app--src--account--orders.json";
import personalInfo_7315117f from "./en/account--app--src--account--personal-info.json";
import warranties_0301789d from "./en/account--app--src--account--warranties.json";
import account_afe6dd13 from "./en/account--app--src--account.json";
import login_fc31d166 from "./en/account--app--src--login.json";
import oms_3534c786 from "./en/orders--app--src--oms.json";
import hooks_5b245a30 from "./en/orders--app--src--order--hooks.json";
import fulfillment_90b045d2 from "./en/orders--app--src--order--order-tracking--fulfillment.json";
import orderTrackingIframes_8301af3a from "./en/orders--app--src--order-tracking-iframes.json";
import order_849bf5b9 from "./en/orders--app--src--order.json";
import chooseRecipient_9fec3697 from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--choose-recipient.json";
import dispatcher_1258d860 from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--dispatcher.json";
import selectItems_3a8ee42e from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--select-items.json";
import share_d2b86d88 from "./en/orders--app--src--orders--gift-receipts--details--share.json";
import details_09c4f89f from "./en/orders--app--src--orders--gift-receipts--details.json";
import manage_fbbea634 from "./en/orders--app--src--orders--gift-receipts--manage.json";
import giftReceipts_478648bf from "./en/orders--app--src--orders--gift-receipts.json";
import hooks_4eace719 from "./en/orders--app--src--orders--hooks.json";
import screens_9b3ebcec from "./en/orders--app--src--orders--hsa-reimburse--screens.json";
import hsaReimburse_3749186e from "./en/orders--app--src--orders--hsa-reimburse.json";
import returnMethod_ec757f2e from "./en/orders--app--src--orders--return-method.json";
import orders_a86775a3 from "./en/orders--app--src--orders.json";
import additionalClaimDocuments_64d9d05d from "./en/returns--app--src--returns--additional-claim-documents.json";
import components_baad9e43 from "./en/returns--app--src--returns--components.json";
import exchangeConversion_31b5d151 from "./en/returns--app--src--returns--exchange-conversion.json";
import returns_0ccce345 from "./en/returns--app--src--returns.json";
import variantPicker_c8533f48 from "./en/returns--app--src--submission--components--variant-picker.json";
import components_c8f7dbfc from "./en/returns--app--src--submission--components.json";
import hooks_d951004c from "./en/returns--app--src--submission--hooks.json";
import addExchangeItem_0aa6c2ac from "./en/returns--app--src--submission--screens--choose-compensation-method--add-exchange-item.json";
import chooseCompensationMethod_f6a99f24 from "./en/returns--app--src--submission--screens--choose-compensation-method.json";
import flowReturn_eb195764 from "./en/returns--app--src--submission--screens--flow-return.json";
import flow_11080d18 from "./en/returns--app--src--submission--screens--flow.json";
import itemDetails_131c1845 from "./en/returns--app--src--submission--screens--item-details.json";
import login_38c568be from "./en/returns--app--src--submission--screens--login.json";
import merchantFlow_dee61aed from "./en/returns--app--src--submission--screens--merchant-flow.json";
import packagePickup_30db431b from "./en/returns--app--src--submission--screens--package-pickup.json";
import review_7d61328e from "./en/returns--app--src--submission--screens--review.json";
import withdrawalReview_c96d1332 from "./en/returns--app--src--submission--screens--withdrawal-review.json";
import submission_b88e3dfc from "./en/returns--app--src--submission.json";
import actionAuthorize_4abc4675 from "./en/src--action-authorize.json";
import csat_d29dc12e from "./en/src--csat.json";
import customization_1da3bcec from "./en/src--customization.json";
import list_8fd75d5d from "./en/src--list.json";
import sharedComponents_522eec4e from "./en/src--portal-four--shared-components.json";
import util_d059057b from "./en/src--util.json";
import login_a933b61d from "./en/ui--src--account--login.json";
import login_0cbefcaa from "./en/ui--src--login.json";
import orderDetails_1cea3a0a from "./en/ui--src--orders--orders--order-details.json";
import merchantOverrides_cd3e7d16 from "./en/ui--src--portal-four--shared-components--merchant-overrides.json";
import sharedComponents_e4b68288 from "./en/ui--src--portal-four--shared-components.json";
import dropoffs_0583a8f4 from "./en/ui--src--returns--returns--components--dropoffs.json";
import components_43ce4bec from "./en/ui--src--returns--returns--components.json";
import cart_fe04af49 from "./en/ui--src--returns--submission--components--cart.json";
import media_e2604836 from "./en/ui--src--returns--submission--components--product-configurator--media.json";
import productOptions_27800f59 from "./en/ui--src--returns--submission--components--product-configurator--product-options.json";
import components_cd9649d4 from "./en/ui--src--returns--submission--components.json";
import cart_c3ea1436 from "./en/ui--src--returns--submission--screens--cart.json";
import chooseCompensationMethod_2b564ecf from "./en/ui--src--returns--submission--screens--choose-compensation-method.json";
import claimDocumentsReturn_19d95e48 from "./en/ui--src--returns--submission--screens--claim-documents-return.json";
import flowInput_dca0e6b0 from "./en/ui--src--returns--submission--screens--flow-input.json";
import itemDetails_fafd36d9 from "./en/ui--src--returns--submission--screens--item-details.json";
import review_85905e9c from "./en/ui--src--returns--submission--screens--review.json";
import selectItems_5c569294 from "./en/ui--src--returns--submission--screens--select-items.json";
import shipmentMethod_485eb42d from "./en/ui--src--returns--submission--screens--shipment-method.json";
import shopNow_5b5bd0a9 from "./en/ui--src--returns--submission--screens--shop-now.json";
import screens_1ed51ee4 from "./en/ui--src--warranties--register--screens.json";
import components_e16f89f8 from "./en/warranties--app--src--register--components.json";
import hooks_631c1a95 from "./en/warranties--app--src--register--hooks.json";
import screens_5c95bcfc from "./en/warranties--app--src--register--screens.json";
import register_7b902d88 from "./en/warranties--app--src--register.json";
import thirdPartyWarranty_def7b5df from "./en/warranties--app--src--third-party-warranty.json";
import policies_2263052d from "./en/warranties--app--src--warranties--policies.json";
import warranties_45249157 from "./en/warranties--app--src--warranties.json";

export default Object.assign(
  {},
  home_48172dae,
  lists_05f113fc,
  orders_ef59f554,
  personalInfo_7315117f,
  warranties_0301789d,
  account_afe6dd13,
  login_fc31d166,
  oms_3534c786,
  hooks_5b245a30,
  fulfillment_90b045d2,
  orderTrackingIframes_8301af3a,
  order_849bf5b9,
  chooseRecipient_9fec3697,
  dispatcher_1258d860,
  selectItems_3a8ee42e,
  share_d2b86d88,
  details_09c4f89f,
  manage_fbbea634,
  giftReceipts_478648bf,
  hooks_4eace719,
  screens_9b3ebcec,
  hsaReimburse_3749186e,
  returnMethod_ec757f2e,
  orders_a86775a3,
  additionalClaimDocuments_64d9d05d,
  components_baad9e43,
  exchangeConversion_31b5d151,
  returns_0ccce345,
  variantPicker_c8533f48,
  components_c8f7dbfc,
  hooks_d951004c,
  addExchangeItem_0aa6c2ac,
  chooseCompensationMethod_f6a99f24,
  flowReturn_eb195764,
  flow_11080d18,
  itemDetails_131c1845,
  login_38c568be,
  merchantFlow_dee61aed,
  packagePickup_30db431b,
  review_7d61328e,
  withdrawalReview_c96d1332,
  submission_b88e3dfc,
  actionAuthorize_4abc4675,
  csat_d29dc12e,
  customization_1da3bcec,
  list_8fd75d5d,
  sharedComponents_522eec4e,
  util_d059057b,
  login_a933b61d,
  login_0cbefcaa,
  orderDetails_1cea3a0a,
  merchantOverrides_cd3e7d16,
  sharedComponents_e4b68288,
  dropoffs_0583a8f4,
  components_43ce4bec,
  cart_fe04af49,
  media_e2604836,
  productOptions_27800f59,
  components_cd9649d4,
  cart_c3ea1436,
  chooseCompensationMethod_2b564ecf,
  claimDocumentsReturn_19d95e48,
  flowInput_dca0e6b0,
  itemDetails_fafd36d9,
  review_85905e9c,
  selectItems_5c569294,
  shipmentMethod_485eb42d,
  shopNow_5b5bd0a9,
  screens_1ed51ee4,
  components_e16f89f8,
  hooks_631c1a95,
  screens_5c95bcfc,
  register_7b902d88,
  thirdPartyWarranty_def7b5df,
  policies_2263052d,
  warranties_45249157,
);
